<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header-light page-title="AUDESP - FASE 4 [Registro de Preço]" fa-icon="file-signature">
          </lib-page-header-light>
          <span class="text-muted" style="font-size: 18px" *ngIf="entidade.id">
            <i [class]="'mt-2 ml-1 fa fa-arrow-circle-down' + (entidade.exportado ? ' text-primary' : '')"
              [title]="(entidade.exportado ? '' : 'Não ') + 'Exportado'"></i>
            <i [class]="'mt-2 ml-1 fa fa-arrow-circle-up' + (entidade.enviado ? ' text-primary' : '')"
              [title]="(entidade.enviado ? '' : 'Não ') + 'Enviado'"></i>
            <i [class]="'mt-2 ml-1 fa fa-check-circle' + (entidade.armazenado ? ' text-success' : '')"
              [title]="(entidade.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
          </span>
        </div>
        <div class="col-md-4">
          <button [routerLink]="['/licitacoes-audesp']" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="voltar" title="Voltar" height="20" width="20">
          </button>
          <div class="dropdown" *ngIf="entidade.id">
            <button class="btn btn-sm btn-outline-secondary float-right dropdown-toggle ml-2" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Opções
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <!-- <a class="dropdown-item" (click)="importarInformacoes()">
                Carregar Informações
              </a> -->
              <a class="dropdown-item" (click)="validarXML()">
                Validar Registro
              </a>
              <a class="dropdown-item" (click)="gerarXML()">
                Gerar Arquivo XML
              </a>
              <a class="dropdown-item" (click)="atualizarStatus('ENVIADO', !entidade.enviado)">
                Marcar como {{entidade.enviado ? 'Não ' : ''}}Enviado
              </a>
              <a class="dropdown-item" (click)="atualizarStatus('ARMAZENADO', !entidade.armazenado)">
                Marcar como {{entidade.armazenado ? 'Não ' : ''}}Armazenado
              </a>
            </div>
          </div>
          <button (click)="submitForm()" class="btn btn-primary btn-sm float-right ml-2"
            *ngIf="!entidade.enviado && !entidade.armazenado">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="row mb-3" *ngIf="!entidade.id">
        <label class="col-md-3 col-form-label required">Selecione a Licitação:</label>
        <div class="col-md-3">
          <p-autoComplete formControlName="licitacao" [field]="licitacaoAutoComplete.conversor"
            (onSelect)="licitacaoAutoComplete.atualizar(false)" [suggestions]="licitacaoAutoComplete.lista"
            (completeMethod)="licitacaoAutoComplete.filtrar($event)" inputStyleClass="form-control" minLength="3"
            [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true" *ngIf="licitacaoAutoComplete">
            <ng-template let-licitacao pTemplate="item">
              {{licitacao.numero | LICITACAO}} - {{licitacao.modalidade?.nome}}
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="col-6">
          <div class="row">
            <label class="required float-left col-9 col-form-label">
              É Adesão a Ata de Registro de Preços de Outro Órgão?
            </label>
            <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
              [(ngModel)]="registroPrecoSim" [ngModelOptions]="{standalone: true}">
              <ng-template let-opcao>
                <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
              </ng-template>
            </p-selectButton>
          </div>
        </div>
      </div>
      <div class="row mt-3 text-muted" *ngIf="entidadeForm.get('licitacao')?.value">
        <div class="col-3">
          <label class="font-weight-bold float-left">Nº Licitação:</label>
          <label class="ml-2">
            <a [routerLink]="['/licitacoes', entidadeForm.get('licitacao').value.id, 'editar']" target="_blank"
              class="btn btn-sm btn-link float-left p-0">
              {{entidadeForm.get('licitacao').value.numero | LICITACAO}}
            </a>
          </label>
        </div>
        <div class="col-3">
          <label class="font-weight-bold">Nº Processo:</label>
          <label class="ml-2">
            {{entidadeForm.get('licitacao').value.processo | LICITACAO}}
          </label>
        </div>
        <div class="col-3">
          <label class="font-weight-bold">Modalidade:</label>
          <label class="ml-2">
            {{entidadeForm.get('licitacao').value.modalidade?.nome}}
          </label>
        </div>
        <div class="col-3">
          <a class="btn btn-link btn-sm text-danger float-right" data-toggle="modal" data-target="#dialogMensagensXML"
            *ngIf="mensagemXML">
            <i class="fa fa-exclamation-triangle"></i> Visualizar Inconsistências
          </a>
        </div>
      </div>
      <hr />
      <app-licitacao-audesp-registro-preco [licitacao]="entidadeForm.get('licitacao')?.value" [(entidade)]="entidade"
        [registroPreco]="registroPrecoSim"></app-licitacao-audesp-registro-preco>
      <lib-licitacao-audesp-ajuste-list *ngIf="entidade.armazenado && entidadeForm.get('licitacao')?.value"
        [licitacao]="entidadeForm.get('licitacao')?.value['id']" [registroPreco]="entidade.id">
      </lib-licitacao-audesp-ajuste-list>
      <!-- <pre>{{ entidade.arquivo | json}}</pre> -->
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal fade" id="dialogMensagensXML" tabindex="-1" role="dialog" 
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        Inconsistências do Registro
      </div>
      <div class="modal-body p-1">
        <ul class="list-group list-group-flush text-muted">
          <li class="list-group-item p-1" *ngFor="let msg of mensagemXML" style="border-style: dashed">
            {{msg}}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-sm text-danger" (click)="baixarXMLInvalido()"
          *ngIf="xmlInvalido">Baixar XML</button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>